// src/components/carousel/videoCarouselFAQDno.ts

// e.g. src/constants/videos.ts
import { DNO_APPROVED, DNO_ADMIN, DNO_REVIEWER } from "../../../constants/roles"
// ...import the rest

export interface IUserFlags {
    groups: string[]
    isSignedIn: boolean
    isInstallerUnapproved: boolean
    isDnoApproved: boolean
}

export interface IVideo {
    id: string
    title: string
}

export const DNO_VIDEOS: IVideo[] = [
    {
        id: "yxFc5zm1WaM",
        title: "How do I register as an Admin?",
    },
    {
        id: "7MW7ccEYTYI",
        title: "Join an organisation",
    },
    {
        id: "Tch1Hj6LWSA",
        title: "Raise a Connect Direct support ticket",
    },
    {
        id: "XMoymFymoYI",
        title: "Search for a company on Connect Direct",
    },
    {
        id: "-jEtx4CQT40",
        title: "Raise a support ticket",
    },
    {
        id: "qJf8ZtKL8ak",
        title: "How to manage commissioning applications",
    },
]

export const getDnoFaqVideoIds = (): string[] => DNO_VIDEOS.map((v) => v.id)

export const getDnoCarousel = (
    userFlags: IUserFlags
): {
    videos: IVideo[]
    shouldShow: boolean
} => {
    const { groups, isSignedIn, isInstallerUnapproved, isDnoApproved } =
        userFlags

    const isDnoUser =
        isDnoApproved ||
        groups.some((role) =>
            [DNO_APPROVED, DNO_ADMIN, DNO_REVIEWER].includes(role)
        )

    const shouldShow = isSignedIn && !isInstallerUnapproved && isDnoUser

    return {
        videos: DNO_VIDEOS,
        shouldShow,
    }
}
